import { Navigate } from 'react-router-dom';

import { AppRoute } from 'share/types/routes';

export const ProtectedRoute = ({
  children,
  enabled
}: {
  children: JSX.Element;
  enabled: boolean;
}) => {
  if (!enabled) {
    return <Navigate replace to={AppRoute.Index} />;
  }

  return children;
};
